import { isFallbackImage } from '~/utilities/isFallbackImage';

export type MissingImage = {
  name: string;
  section: string;
};

export type ImageGroup = {
  items: Array<{ imageUrl: string; name: string }>;
  section: string;
};

export default function findMissingImages(
  groups: ImageGroup[]
): MissingImage[] {
  return groups.flatMap(({ items, section }) =>
    items
      .filter(({ imageUrl }) => isFallbackImage(imageUrl))
      .map(({ name }) => ({ name, section }))
  );
}
